'use strict';

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);
}

function displayTime(value) {
  return value ? new Date(value).toLocaleString('zh-CN') : '—';
}

module.exports = { escapeHtml, displayTime };
